export default __webpack_public_path__ + "images/0xc0d3700000987c99b3c9009069e4f8413fd22330.png";